const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const StandardStrike = require('../StandardStrike');
const DamageEvent = require('../../events/DamageEvent');
const BattleEventFactory = require('../../events/BattleEventFactory');
const { logError } = require('../../logger');

const Slam = function(battleState) {
  this.handle = 'slam';
  this.physical = true;
  this.melee = true;
  this.weapon = true;
  this.harm = true;

  this.standardStrike = new StandardStrike(this, battleState);

  this.eventEmitter = new EventEmitter();

  this.isLegal = function(actor, victim) {
    return victim.unit;
  };

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
      return { success: false };
    }

    try {
      var ability = BattleCalc.getEquippedAbility(actor, this.handle);

      var result = this.standardStrike.execute(
        actor,
        victim,
        ability.damage,
        true,
      );
      result.abilityHandle = this.handle;

      if (result.success && !victim.dead) {
        BattleEventFactory.makeKnockbackEvent(
          battleState,
          battleState.getTileAtCoords(actor.x,actor.y),
          victim,
          ability.potency,
        );
      }

      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim? victim.uid : null;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'Slam',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
};
module.exports = Slam;
